export const SWIPE_DOWN_THRESHOLD_PX = 80
export const SWIPE_HORIZONTAL_THRESHOLD_PX = 60
export const SWIPE_EDGE_ZONE_PX = 30
export const SWIPE_TAP_THRESHOLD_PX = 40
